
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { VuetifyMixin } from '../../mixins';

@Component
export default class WarmupSvg extends Mixins(VuetifyMixin){
	@Prop({ default: 'baColorPrimaryBlue' }) private color: string;
	get Color(): string{
		return this.getColor(this.color);
	}
}
